import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';
import { IPaginatorProperties } from 'src/app/core/models/paginator.interface';

export interface ICoverageMapItem {
    id: number;
    carrierId: number;
    postcode: string;
    densityZone: string;
}

@Injectable({
    providedIn: 'root'
})
export class CarrierCoverageMapService extends ApiService {

    public getList(
        carrierId: number,
        page: number = 1,
        limit: number = 100,
        q: string = '',
        orderField: string = '',
        orderDirection: string = ''
    ): Observable<IPaginatorProperties<ICoverageMapItem>> {
        return this.request({
            method: 'GET',
            path: 'carrier-postal-codes-coverage-map',
            query: {
                carrierId,
                page,
                limit,
                q,
                orderField,
                orderDirection,
            },
        });
    }

    public create(body: { carrierId: number; postcode: string; densityZone?: string }): Observable<ICoverageMapItem> {
        return this.request({
            method: 'POST',
            path: 'carrier-postal-codes-coverage-map',
            body,
        });
    }

    public update(id: number, body: { postcode?: string; densityZone?: string }): Observable<ICoverageMapItem> {
        return this.request({
            method: 'PUT',
            path: `carrier-postal-codes-coverage-map/${id}`,
            body,
        });
    }

    public delete(id: number): Observable<any> {
        return this.request({
            method: 'DELETE',
            path: `carrier-postal-codes-coverage-map/${id}`,
        });
    }
}
